<template>
  <div class="m-icon" :style="{ width, height }">
    <img v-if="is('image')" v-bind="config" />
  </div>
</template>

<script>
export default {
  props: {
    width: String,
    height: String,
    type: String,
    config: Object
  },
  methods: {
    is(type) {
      return type === this.type;
    }
  }
};
</script>

<style lang="scss" scoped>
.m-icon {
  display: inline-block;

  img {
    width: 100%;
    height: 100%;

    object-fit: scale-down;
  }
}
</style>
